var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect } from 'react';
import { FormContainer, FormGrid, GeneralErrorText } from './styles';
import { BuildingInformationSection, ApplicantInformationSection, ServiceRequestSection, TicketManagementSection, } from 'src/Components';
import Cookies from 'js-cookie';
import { TYPE_CONTACT } from 'src/Utils/constants';
import { useTicketForm, validateExternalTicketForm, } from '../shared';
import { useTicketAlerts } from '../shared/hooks/useTicketAlerts';
import { TicketAlertsModal } from '../TicketAlertsModal';
export var TicketForm = function (_a) {
    var buildingId = _a.buildingId, onSubmittingChange = _a.onSubmittingChange;
    var isContact = Cookies.get('User') === TYPE_CONTACT;
    var initialFormData = {
        internal: false,
        building_id: buildingId !== null && buildingId !== void 0 ? buildingId : null,
        building_code: '',
        tower_id: null,
        tower_code: '',
        apartment_id: null,
        apartment_number: '',
        relation: '',
        client_selection: 'other',
        apartment_contact_id: null,
        external_client_first_name: '',
        external_client_last_name: '',
        external_client_email: '',
        external_client_phone: '',
        title: '',
        provider_service: '',
        description: '',
        assignee_id: null,
        communication_channel: 'phone',
    };
    var _b = useTicketForm({
        initialFormData: initialFormData,
        isInternal: false,
        customValidation: validateExternalTicketForm,
        requireCommunicationChannel: !isContact,
    }), _c = _b.formState, formData = _c.formData, errors = _c.errors, isSubmitting = _c.isSubmitting, _d = _b.formActions, handleInputChange = _d.handleInputChange, handleSubmit = _d.handleSubmit, setFormData = _d.setFormData, buildings = _b.buildings, towers = _b.towers, apartments = _b.apartments;
    var alertsBuildingId = isContact ? null : formData.building_id;
    var alertsApartmentId = isContact ? null : formData.apartment_id;
    var _e = useTicketAlerts({
        buildingId: alertsBuildingId,
        apartmentId: alertsApartmentId,
        buildings: buildings,
        apartments: apartments,
    }), alertModal = _e.alertModal, closeAlertModal = _e.closeAlertModal;
    useEffect(function () {
        if (onSubmittingChange) {
            onSubmittingChange(isSubmitting);
        }
    }, [isSubmitting, onSubmittingChange]);
    useEffect(function () {
        if (buildingId != null && buildings.length > 0 && !formData.building_code) {
            var selectedBuilding_1 = buildings.find(function (building) { return building.id === buildingId; });
            if (selectedBuilding_1) {
                setFormData(function (prev) { return (__assign(__assign({}, prev), { building_id: buildingId, building_code: selectedBuilding_1.code || '' })); });
            }
        }
    }, [buildingId, buildings, formData.building_code, setFormData]);
    var canUseApplicantSection = !!formData.building_id;
    var canUseStructuredClient = !!formData.building_id &&
        !!formData.tower_id &&
        !!formData.apartment_id &&
        !!formData.relation;
    useEffect(function () {
        if (!canUseStructuredClient && formData.client_selection !== 'other') {
            setFormData(function (prev) { return (__assign(__assign({}, prev), { client_selection: 'other', apartment_contact_id: null })); });
        }
    }, [canUseStructuredClient, formData.client_selection, setFormData]);
    useEffect(function () {
        if (canUseStructuredClient && formData.client_selection === 'other') {
            setFormData(function (prev) { return (__assign(__assign({}, prev), { client_selection: 'existing' })); });
        }
    }, [canUseStructuredClient, formData.client_selection, setFormData]);
    return (React.createElement(FormContainer, { id: "ticket-form", onSubmit: function (e) {
            e.preventDefault();
            if (isSubmitting)
                return;
            handleSubmit();
        } },
        React.createElement(FormGrid, null,
            React.createElement(BuildingInformationSection, { formData: {
                    building_id: formData.building_id,
                    building_code: formData.building_code,
                    tower_id: formData.tower_id,
                    tower_code: formData.tower_code,
                    apartment_id: formData.apartment_id,
                    apartment_number: formData.apartment_number,
                    relation: formData.relation,
                }, buildings: buildings, towers: towers, apartments: apartments, errors: errors, onInputChange: handleInputChange, showRelation: !isContact }),
            !isContact && (React.createElement(ApplicantInformationSection, { formData: {
                    apartment_id: formData.apartment_id,
                    client_selection: formData.client_selection,
                    apartment_contact_id: formData.apartment_contact_id,
                    external_client_first_name: formData.external_client_first_name,
                    external_client_last_name: formData.external_client_last_name,
                    external_client_email: formData.external_client_email,
                    external_client_phone: formData.external_client_phone,
                    relation: formData.relation,
                }, errors: errors, onInputChange: handleInputChange, disabled: !canUseApplicantSection, canUseStructuredClient: canUseStructuredClient })),
            React.createElement(ServiceRequestSection, { formData: {
                    title: formData.title,
                    provider_service: formData.provider_service,
                    description: formData.description,
                    communication_channel: formData.communication_channel,
                }, errors: errors, onInputChange: handleInputChange, showCommunicationChannel: !isContact }),
            !isContact && (React.createElement(TicketManagementSection, { formData: {
                    assignee_id: formData.assignee_id,
                }, onInputChange: handleInputChange }))),
        errors.general && React.createElement(GeneralErrorText, null, errors.general),
        !isContact && (React.createElement(TicketAlertsModal, { isOpen: alertModal.isOpen, onClose: closeAlertModal, alerts: alertModal.alerts, buildingName: alertModal.buildingName, apartmentNumber: alertModal.apartmentNumber }))));
};
export default TicketForm;
